function showNavItem(navItem, delay){
    setTimeout(function(){
        navItem.classList.add('show');
    }, delay);
}

function hideNavItem(navItem, delay){
    setTimeout(function(){
        navItem.classList.remove('show');
    }, delay);
}

function openHeaderMenu() {
    var toggler = $('#menuHeaderToggler');
    var menuHeader = $('#menuHeader');
    var header = $('#header');
    var menuHeight = menuHeader.outerHeight();
    var headerHeight = header.outerHeight();
    var phoneButton = header.find('.btn.btn-green');

    var menuOffset = headerHeight;

    if( $('#wpadminbar').length > 0 ) {
        menuOffset += $('#wpadminbar').outerHeight();
    }

    header.data('state','menuOpening');
    menuHeader.addClass('show');
    toggler.addClass('show');
    menuHeader.css({display:'block'});
    $('body').css({'overflow-y':'hidden'})
    menuHeader.animate({top: (0 + menuOffset) }, 300);

    var navItems = menuHeader.find('li.main-menu-item');
        // console.log(navItems);

    var delay = 200;

    for( var i = 0; i < navItems.length; i++ ) {

        showNavItem(navItems[i], delay);

        delay += 120;
    }

    setTimeout(function(){
        phoneButton.addClass('show');
    }, 300);

    setTimeout(function(){
        header.data('state','menuOpen');
    }, 900);
}

function closeHeaderMenu() {
    var toggler = $('#menuHeaderToggler');
    var menuHeader = $('#menuHeader');
    var header = $('#header');
    var menuHeight = menuHeader.outerHeight();
    var headerHeight = header.outerHeight();
    var phoneButton = header.find('.btn.btn-green');

    var menuOffset = headerHeight;


    if( $('#wpadminbar').length > 0 ) {
        menuOffset += $('#wpadminbar').outerHeight();
    }

    header.data('state','menuClosing');
    toggler.removeClass('show');
    phoneButton.removeClass('show');

    $('body').css({'overflow-y':'visible'});

    var navItems = menuHeader.find('li.main-menu-item');
        // console.log(navItems);

    var delay = 0;

    for( var i = navItems.length - 1; i >= 0; i-- ) {

        hideNavItem(navItems[i], delay);

        delay += 30;
    }

    setTimeout(function(){
        menuHeader.removeClass('show');
        menuHeader.animate({top: (0 - menuHeight) }, 300);
    }, 300);

    setTimeout(function(){
        menuHeader.css({display:'none'});
        header.data('state','menuClosed');
    }, 600);
}

function toggleHeaderMenu(){
    var header = $('#header');
    // console.log(header.data('state'));

    if( header.data('state') !== 'menuClosing' && header.data('state') !== 'menuOpening' ) {
        if( $('#menuHeaderToggler').hasClass('show') ) {
            closeHeaderMenu();
        } else {
            openHeaderMenu();
        }
    }
}

function resetHeaderMenu() {
    var header = $('#header');
    var menuHeader = $('#menuHeader');
    var menuHeaderToggler = $('#menuHeaderToggler');

    header.data('state','resetting');

    menuHeader.removeClass('show');
    menuHeaderToggler.removeClass('show');

    $('body').css({'overflow-y':'visible'});

    menuHeader.css({'top':(0 - menuHeader.outerHeight()) + header.outerHeight(),'display':'none'});

    header.data('state','default');
}

$('#menuHeaderToggler').click(function(){
    toggleHeaderMenu();
})

$(document).ready(function(){
    var header = $('#header');

    var menuHeader = $('#menuHeader');

    console.log();

    menuHeader.css({top: (0 - menuHeader.outerHeight()) + header.outerHeight() });

    header.data('state','default');
})

$(window).resize(function(){
    resetHeaderMenu();
})

$('#menuHeaderToggler').keydown(function(e) {
    var code = e.keyCode || e.which;

    console.log(e.keyCode);

    if (code === 13) {
        e.preventDefault();

        if( $('#menuHeaderToggler').hasClass('show') ) {
            closeHeaderMenu();
        } else {
            openHeaderMenu();
            $('#menu-header-nav').find('li').first().find('a').focus();
        }
    }
});

$(document).keydown(function(e) {
    var code = e.keyCode || e.which;

    if (code === 27) {
        e.preventDefault();

        if( $('#menuHeaderToggler').hasClass('show') ) {
            closeHeaderMenu();
        }
    }
})
